export enum PropertyTypes {
  HOUSE = 'house',
  APARTMENT = 'apartment',
  TERRAIN = 'terrain',
  OTHER = 'other'
}

export enum OperationTypes {
  SALE = 'for-sale',
  LEASE = 'for-rent',
  PRESALE = 'for-presale'
}